<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.53 8.72a.75.75 0 010 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 011.06-1.06l2.72 2.72V2.75a.75.75 0 011.5 0v8.69l2.72-2.72a.75.75 0 011.06 0z"
    fill="currentColor"
  />
</svg>
